import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const checkBrightdataRunStatus = unaryRpc({
  name: "checkBrightdataRunStatus",
  input: z.object({ sessionId: z.string() }),
  output: z.object({
    status: z.enum(["running", "ready", "failed"]),
    snapshotId: z.string(),
    datasetId: z.string(),
    records: z.number().optional(),
    errors: z.number().optional(),
    collectionDuration: z.number().optional(),
    notifyError: z.string().optional(),
  }),
});
